import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import Liegenschaften from "@/pages/Liegenschaften";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Units from "@/pages/Units";
import UnitDetail from "@/pages/UnitDetail";
import Tenants from "@/pages/Tenants";
import FehlendeMieter from "@/pages/FehlendeMieter";
import Turnovers from "@/pages/Turnovers";
import TurnoverDetail from "@/pages/TurnoverDetail";
import NewTurnover from "@/pages/NewTurnover";
import Wiki from "@/pages/Wiki";
import Mietkonto from "@/pages/Mietkonto";
import Aufgaben from "@/pages/Aufgaben";
import Widersprueche from "@/pages/Widersprueche";
import Durchsicht from "@/pages/Durchsicht";
import Konten from "@/pages/Konten";
import Zugaenge from "@/pages/Zugaenge";
import Historie from "@/pages/Historie";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/lib/auth";

// Die Wache steht hier und nicht in jeder Seite: solange nicht feststeht, WER
// da ist, wird nichts geladen. Sonst schickt jede Seite beim Aufbau ihre
// Abfragen los, bekommt 401 und der Nutzer sieht eine kaputte Oberflaeche
// statt einer Anmeldemaske.
function Angemeldet() {
    const { angemeldet, laedt } = useAuth();

    if (laedt) {
        return (
            <div className="min-h-screen grid place-items-center bg-gray-50">
                <div className="text-sm text-gray-400">Anmeldung wird geprüft …</div>
            </div>
        );
    }
    if (!angemeldet) return <Login />;

    return (
        <BrowserRouter>
            <Layout>
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/entitaeten" element={<Entities />} />
                        <Route path="/entitaeten/:id" element={<EntityDetail />} />
                        <Route path="/liegenschaften" element={<Liegenschaften />} />
                        <Route path="/immobilien" element={<Properties />} />
                        <Route path="/immobilien/:id" element={<PropertyDetail />} />
                        <Route path="/einheiten" element={<Units />} />
                        <Route path="/einheiten/:id" element={<UnitDetail />} />
                        <Route path="/mieter" element={<Tenants />} />
                        <Route path="/mieter/fehlend" element={<FehlendeMieter />} />
                        <Route path="/wechsel" element={<Turnovers />} />
                        <Route path="/wechsel/neu" element={<NewTurnover />} />
                        <Route path="/wechsel/:id" element={<TurnoverDetail />} />
                        <Route path="/aufgaben" element={<Aufgaben />} />
                        <Route path="/widersprueche" element={<Widersprueche />} />
                        <Route path="/mietkonto" element={<Mietkonto />} />
                        <Route path="/mietkonto/durchsicht" element={<Durchsicht />} />
                        <Route path="/konten" element={<Konten />} />
                        <Route path="/wiki" element={<Wiki />} />
                        <Route path="/zugaenge" element={<Zugaenge />} />
                        <Route path="/historie" element={<Historie />} />
                    </Routes>
            </Layout>
        </BrowserRouter>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <Angemeldet />
            </AuthProvider>
        </div>
    );
}

export default App;
